// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__BlMhd","bigColWidth":"Table_bigColWidth__Ysykw","biggerColWidth":"Table_biggerColWidth__1obb_","row":"Table_row__CkdOe","col":"Table_col__2Bfic"};